export enum UserPreferenceSettingName {
    ggzConsultDecisionAidDefaultClosed = 'ggzConsultDecisionAidDefaultClosed',
}
